import React, { type JSX } from 'react';
import {
  Avatar,
  Box,
  ClickAwayListener,
  IconButton,
  Menu,
  MenuItem,
  styled,
} from '@mui/material';
import { Link, router } from '@inertiajs/react';
import Person from '@mui/icons-material/Person';
import Logout from '@mui/icons-material/Logout';

type Props = {
  username: string;
  profilePhoto: string;
};

export const UserMenu = ({ username, profilePhoto }: Props): JSX.Element => {
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null,
  );

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = (): void => {
    setAnchorElUser(null);
  };

  const logout = (e: React.SyntheticEvent): void => {
    e.preventDefault();
    router.post(route('logout'));
  };

  return (
    <ClickAwayListener onClickAway={handleCloseUserMenu}>
      <Box sx={{ flexGrow: 0 }}>
        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
          <Avatar alt={username} src={profilePhoto} />
        </IconButton>
        <Menu
          sx={{ mt: '45px' }}
          id="menu-appbar"
          anchorEl={anchorElUser}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={Boolean(anchorElUser)}
          onClose={handleCloseUserMenu}
        >
          <MenuItem onClick={handleCloseUserMenu} disableGutters sx={{ py: 0 }}>
            <MenuLink href={route('profile')} sx={{ py: '6px' }}>
              <Person fontSize="small" />
              Profile
            </MenuLink>
          </MenuItem>
          <MenuItem onClick={handleCloseUserMenu} disableGutters sx={{ py: 0 }}>
            <MenuLink href="#" onClick={logout} sx={{ py: '6px' }}>
              <Logout fontSize="small" />
              Sign out
            </MenuLink>
          </MenuItem>
        </Menu>
      </Box>
    </ClickAwayListener>
  );
};

const MenuLink = styled(Link)(
  ({ theme }) => `
  display: flex;
  gap: 0.75rem;
  align-items: center;
  color: ${theme.palette.secondary.main};
  font-weight: 500;
  text-decoration: none;
  padding: 0 1rem;
  width: 100%;

  &:hover {
    opacity: 0.7;
  }

  &:active {
    text-decoration: underline;
  }
`,
);
